import type { NextPage } from 'next'
import { AIChatProvider } from '@/components/landingpages/ai-chat/AIChatContext'
import { AIChatPage } from '@/components/landingpages/ai-chat/AIChatPage'

const AIChatPageRoute: NextPage = () => {
    return (
        <div className="-m-4 h-[calc(100vh-0px)]">
            <AIChatProvider>
                <AIChatPage />
            </AIChatProvider>
        </div>
    )
}

export default AIChatPageRoute
